import { newsArticles } from '@/mocks/content';
import SectionHeading from './SectionHeading';

export default function NewsSection() {
  return (
    <section id="news" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          kicker="Latest News"
          title="影讯速递：片单观察与选片常识"
          desc="除了影片本身，了解一点行业与观影常识能让选片更从容。这里整理了片单观察、院线知识、榜单维度与在家观影设置等内容。"
        />

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {newsArticles.map((article) => (
            <article
              key={article.id}
              className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <div className="w-full aspect-[3/2] overflow-hidden">
                <img
                  src={article.image}
                  alt=""
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex flex-col flex-1 p-4 md:p-5">
                <div className="flex items-center gap-2 text-xs">
                  <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-800 font-medium">{article.category}</span>
                  <span className="text-foreground-400">{article.date}</span>
                </div>
                <h3 className="mt-3 text-sm md:text-base font-bold text-foreground-950 leading-snug line-clamp-2">{article.title}</h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-3">{article.excerpt}</p>
                <span className="mt-4 pt-3 flex items-center justify-between text-xs text-foreground-400 border-t border-background-200">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line" />
                    {article.readTime}
                  </span>
                  <span className="flex items-center gap-1 text-primary-600 group-hover:gap-2 transition-all">
                    阅读
                    <i className="ri-arrow-right-line" />
                  </span>
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}